import { render, staticRenderFns } from "./online_inventory.vue?vue&type=template&id=8ecb0de0&"
import script from "./online_inventory.vue?vue&type=script&lang=js&"
export * from "./online_inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports